// 案件ステータスの定義（フロー順）。管理画面の複数ページで共有する。
// フロー: chatting → estimated → decided → invoiced → paid → scheduled → in_progress → completion_notified → completed
export const STATUS_FLOW = [
    { value: 'chatting',            step: 1, label: 'すり合わせ中',   bg: '#dbeafe', color: '#1d4ed8' },
    { value: 'estimated',           step: 2, label: '見積確認待ち',   bg: '#ffedd5', color: '#c2410c' },
    { value: 'decided',             step: 3, label: '発注済み',       bg: '#ccfbf1', color: '#0f766e' },
    { value: 'invoiced',            step: 4, label: '請求書確認',     bg: '#fee2e2', color: '#b91c1c' },
    { value: 'paid',                step: 5, label: '支払済み',       bg: '#dcfce7', color: '#15803d' },
    { value: 'scheduled',           step: 6, label: '日程確定',       bg: '#e0e7ff', color: '#4338ca' },
    { value: 'in_progress',         step: 7, label: '工事中',         bg: '#cffafe', color: '#0e7490' },
    { value: 'completion_notified', step: 8, label: '完了確認待ち',   bg: '#fef9c3', color: '#a16207' },
    { value: 'completed',           step: 9, label: '完了',           bg: '#f3f4f6', color: '#6b7280' },
];

// フローから外れる分岐ステータス（番号は振らない）
export const STATUS_BRANCHES = [
    { value: 'lost',      label: '失注（他社に決定）', bg: '#f3f4f6', color: '#9ca3af' },
    { value: 'cancelled', label: 'キャンセル/返金',    bg: '#fee2e2', color: '#b91c1c' },
];

// バッジ表示用（番号付きラベル）: { chatting: { label: '1. すり合わせ中', bg, color }, ... }
export const STATUS_MAP = Object.fromEntries([
    ...STATUS_FLOW.map(s => [s.value, { label: `${s.step}. ${s.label}`, bg: s.bg, color: s.color }]),
    ...STATUS_BRANCHES.map(s => [s.value, { label: s.label, bg: s.bg, color: s.color }]),
]);

// ステータス強制変更セレクト用（番号付きラベル）
export const STATUS_OPTIONS = [
    ...STATUS_FLOW.map(s => ({ value: s.value, label: `${s.step}. ${s.label}` })),
    ...STATUS_BRANCHES.map(s => ({ value: s.value, label: s.label })),
];
